export default __webpack_public_path__ + "static/media/CateriumOre.256.b72b71c3.png";